import { dayjsUTC } from "../../utils/dates"

export interface NwssEventWindow {
  startDate: string
  endDate: string
}

/** True when any day in the week ending on ``weekEndKey`` overlaps the event window. */
export const weekOverlapsNwssEventWindow = (
  weekEndKey: string,
  window: NwssEventWindow | null | undefined
): boolean => {
  if (!window?.startDate || !window.endDate) return false
  const weekEnd = dayjsUTC(weekEndKey)
  const weekStart = weekEnd.subtract(6, "day")
  const eventStart = dayjsUTC(window.startDate)
  const eventEnd = dayjsUTC(window.endDate)
  return (
    !weekEnd.isBefore(eventStart, "day") && !weekStart.isAfter(eventEnd, "day")
  )
}

export interface NwssEventWindowWeekSpan {
  startIndex: number
  endIndex: number
}

/** Inclusive week-column indices on the chart that overlap the event window. */
export const nwssEventWindowWeekSpan = (
  weekKeys: readonly string[],
  window: NwssEventWindow | null | undefined
): NwssEventWindowWeekSpan | null => {
  if (!window?.startDate || !window.endDate || weekKeys.length === 0) {
    return null
  }

  let startIndex = -1
  let endIndex = -1
  weekKeys.forEach((weekKey, index) => {
    if (!weekOverlapsNwssEventWindow(weekKey, window)) return
    if (startIndex === -1) startIndex = index
    endIndex = index
  })

  if (startIndex === -1) return null
  return { startIndex, endIndex }
}
